import { useEffect, useState } from 'react'

import { simpleContract } from '../utility/contract'
import { convertFromWei } from '../utility/helpers'


export const useGetMintedData = () => {
    const [step, setStep] = useState(0)
    const [whiteList, setWhiteList] = useState(false)
    const [mintingPricePeb, setMintingPricePeb] = useState(0)
    const [mintingLimit, setMintingLimit] = useState(0)
    const [mintingIdx, setMintingIdx] = useState(0)
    const [mintingStartBlock, setMintingStartBlock] = useState(0)
    const [loading, setLoading] = useState(true)
    const [error, setError] = useState(null)

    useEffect(async () => {
        updateMintedData();
    }, [])

    const updateMintedData = async () => {
        try {

            setStep(await simpleContract.methods.getStep().call());
            setMintingPricePeb(await simpleContract.methods.getMintingPricePeb().call());
            setMintingLimit(await simpleContract.methods.getMintingLimit().call());
            setMintingStartBlock(await simpleContract.methods.firstStartBlock().call());
            setMintingIdx(await simpleContract.methods.mintIdx().call());
            setLoading(false)
        } catch (error) {
            setLoading(false)
            setError('There was an error getting the data')
        }
    }

    const updateWhiteList = async (addr) => {
        try {
            setWhiteList(await simpleContract.methods.isWhiteList(addr).call());
        } catch (error) {
            setError('There was an error getting the data')
        }
    }

    const getStep = () => {
        switch (step) {
            case '0':
                return 'Not Started';
            case '1':
                return '1st Whitelist';
            case '2':
                return '2nd Whitelist';
            default:
                return 'Public Minting';
        }
    }

    const getMintingPrice = () => {
        return convertFromWei(mintingPricePeb.toString());
    }

    const getMintingLimit = () => {
        return parseInt(mintingLimit);
    }

    const getMintingIdx = () => {
        return parseInt(mintingIdx);
    }

    const getMintingStartBlock = () => {
        return mintingStartBlock;
    }

    const getMintingMax = () => {
        return 1000;
    }

    const getAirdropCount = () => {
        return 0;
    }

    const isWhiteList = () => {
        return whiteList;
    }

    return [
        getStep,
        getMintingPrice,
        getMintingLimit,
        getMintingIdx,
        getMintingStartBlock,
        getMintingMax,
        getAirdropCount,
        isWhiteList,
        updateMintedData,
        updateWhiteList,
        loading
    ]
}